/**
 * Created by andrey on 16.05.2025
 */

import CleverAppsNative from "./cleverappsnative";
import Utils from "./utils";

const debugMode = process.env.VUE_APP_MODE === "staging";

const clientId = "ca-pub-9277187477340577";

const GoogleAds = {
    showAdFn: undefined,
    showAdCallback: undefined,

    cacheInterstitial: function (callback) {
        callback(CleverAppsNative.CODE_SUCCEED);
    },

    connect: function (callback) {
        if (window.googleadsReady) {
            callback(CleverAppsNative.CODE_SUCCEED);
            return;
        }

        window.googleadsOnReady = () => {
            callback(CleverAppsNative.CODE_SUCCEED);
        };
    },
    
    cacheRewarded: function (callback) {
        if (this.showAdFn) {
            callback(CleverAppsNative.CODE_SUCCEED);
            return;
        }

        let code = "rewarded_unknown_error";
        window.adsbygoogle.push({
            name: "rewarded",
            type: "reward",
            beforeReward: (showAdFn) => {
                this.showAdFn = showAdFn;
                callback(CleverAppsNative.CODE_SUCCEED);
            },
            adViewed: () => {
                code = CleverAppsNative.CODE_SUCCEED;
            },
            adDismissed: () => {
                code = "closed_by_user";
            },
            adBreakDone: () => {
                if (this.showAdCallback) {
                    this.showAdCallback(code);
                    this.showAdCallback = undefined;
                } else {
                    callback();
                }
            }
        });
    },

    play: function (options, callback) {
        const name = options.name;

        if (name === "interstitial") {
            window.adsbygoogle.push({
                name,
                type: "start",
                beforeAd: () => {
                    console.log("Interstitial started");
                },
                adBreakDone: () => {
                    console.log("Interstitial finished");
                    callback && callback(CleverAppsNative.CODE_SUCCEED);
                }
            });
            return;
        }

        if (typeof this.showAdFn !== "function") {
            callback && callback("rewarded_not_found");
            return;
        }

        this.showAdCallback = callback;
        this.showAdFn();

        this.showAdFn = undefined;
    }
};

export default {
    install: function () {
        CleverAppsNative.addPlugin("GoogleAds", GoogleAds);

        Utils.loadSdk(`//fundingchoicesmessages.google.com/i/${clientId}?ers=1`, { crossorigin: false });

        const attrs = {
            "data-ad-client": clientId,
            "data-ad-frequency-hint": "5s"
        };

        if (debugMode) {
            attrs["data-adbreak-test"] = "on";
            attrs["data-ad-test"] = "on";
        }

        Utils.loadSdk(`//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${clientId}`, { attrs });

        console.log("adsbygoogle init");
        window.adsbygoogle = window.adsbygoogle || [];

        window.adsbygoogle.push({
            preloadAdBreaks: "on",
            sound: "on",
            onReady: () => {
                console.log("adsbygoogle ready");

                window.googleadsReady = true;

                if (window.googleadsOnReady) {
                    window.googleadsOnReady();
                    delete window.googleadsOnReady;
                }
            }
        });
    }
};